import { HOME_COPY } from "../home.copy";
import { resolvePriceLabel } from "@/lib/plans/price-on-request";
import { Plan } from "@/services/plans/types";

interface PriceOnRequestBlockProps {
  plan: Plan;
  /** Linha de apoio abaixo do rótulo — muda por card. */
  description: string;
}

/**
 * Estado de preço escondido, compartilhado entre os cards da vitrine. Os dois
 * caminhos que levam até aqui (flag do administrativo e dado de preço
 * incompleto) mostram exatamente a mesma coisa: para quem lê, a diferença não
 * existe.
 */
export const PriceOnRequestBlock = ({
  plan,
  description,
}: PriceOnRequestBlockProps) => (
  <div className="flex flex-col gap-1.5">
    <span className="text-xs font-bold uppercase tracking-[0.09em] text-tami-green">
      {resolvePriceLabel(plan)}
    </span>
    <span className="text-3xl font-bold leading-tight text-tami-light">
      {HOME_COPY.priceOnRequest.title}
    </span>
    <p className="text-sm leading-snug text-tami-light/70">{description}</p>
  </div>
);
